/*  @flow */
import * as React from 'react';

import ActionButton from 'components/ActionsList/components/ActionButton/ActionButton';
import LoadingWrapper from 'components/LoadingWrapper/LoadingWrapper';

import {
  createExportData,
  updateAssignedUsers,
  updateEditAccount,
  updateDisableEnableAccount,
  updateArchiveUnarchiveAccount,
  viewAssetRequestForm,
  viewLicenseRequestForm,
} from 'permissions/account';
import { rushAssetRequestFormPermissions } from 'permissions/rush';

import styles from '../../../ActionDrawer/ActionDrawer.module.scss';

const actionsListData: any = [
  {
    label: 'general:actions.assign_user_plural',
    icon: '#icon-users',
    class: 'hello',
    action: 'assignUser',
    type: 'drawer',
    permissions: updateAssignedUsers,
    condition(account: Object, action: Object, callback: Function): React.Node {
      return <ActionButton action={action} onActionDrawer={callback} />;
    },
  },
  {
    label: 'general:actions.remove_user_plural',
    icon: '#icon-users',
    class: '',
    action: 'removeUser',
    type: 'drawer',
    permissions: updateAssignedUsers,
    condition(account: Object, action: Object, callback: Function): React.Node {
      return (
        <ActionButton
          action={action}
          data={account}
          disabled={account.users_count === 0}
          onActionDrawer={callback}
        />
      );
    },
  },
  {
    label: 'general:actions.edit_trading_account',
    icon: '#icon-edit',
    class: '',
    action: 'edit',
    type: 'link',
    to: { pathname: '/accounts/edit', setStateData: true },
    permissions: updateEditAccount,
  },
  {
    label: 'general:actions.export_owned_asset_data',
    icon: '#icon-export-asset-data',
    class: '',
    action: 'export',
    type: 'download',
    permissions: createExportData,
    condition(data: Object, action: Object, drawer: Function, download: Function): React.Node {
      return (
        <LoadingWrapper
          auto={false}
          type={'export-ta-data--owned'}
          classes={styles['loading-action-button']}
        >
          {loadingKey => (
            <ActionButton
              action={action}
              data={data}
              disabled={data.owned_assets_count === 0}
              onActionDownload={() => {
                download('owned', loadingKey);
              }}
            />
          )}
        </LoadingWrapper>
      );
    },
  },
  {
    label: 'general:actions.export_rental_asset_data',
    icon: '#icon-export-asset-data',
    class: '',
    action: 'export',
    type: 'download',
    permissions: createExportData,
    condition(data: Object, action: Object, drawer: Function, download: Function): React.Node {
      return (
        <LoadingWrapper
          auto={false}
          type={'export-ta-data--all'}
          classes={styles['loading-action-button']}
        >
          {loadingKey => (
            <ActionButton
              action={action}
              data={data}
              disabled={data.rental_assets_count === 0}
              onActionDownload={() => {
                download('rental', loadingKey);
              }}
            />
          )}
        </LoadingWrapper>
      );
    },
  },
  {
    label: 'general:actions.export_assets_returned',
    icon: '#icon-export-asset-data',
    class: '',
    action: 'export',
    type: 'download',
    permissions: createExportData,
    condition(data: Object, action: Object, drawer: Function, download: Function): React.Node {
      return (
        <LoadingWrapper
          auto={false}
          type={'export-ta-data--all'}
          classes={styles['loading-action-button']}
        >
          {loadingKey => (
            <ActionButton
              action={action}
              data={data}
              disabled={data.returned_assets_count === 0}
              onActionDownload={() => {
                download('returned', loadingKey);
              }}
            />
          )}
        </LoadingWrapper>
      );
    },
  },
  {
    label: 'general:actions.export_assets_purchased',
    icon: '#icon-export-asset-data',
    class: '',
    action: 'export',
    type: 'download',
    permissions: createExportData,
    condition(data: Object, action: Object, drawer: Function, download: Function): React.Node {
      return (
        <LoadingWrapper
          auto={false}
          type={'export-ta-data--all'}
          classes={styles['loading-action-button']}
        >
          {loadingKey => (
            <ActionButton
              action={action}
              data={data}
              disabled={data.sales_assets_count === 0}
              onActionDownload={() => {
                download('purchase', loadingKey);
              }}
            />
          )}
        </LoadingWrapper>
      );
    },
  },
  {
    label: 'general:actions.export_asset_request_data',
    icon: '#icon-export-asset-data',
    class: '',
    action: 'export',
    type: 'download',
    permissions: createExportData,
    condition(data: Object, action: Object, drawer: Function, download: Function): React.Node {
      return (
        data.asset_request_form_enabled && (
          <LoadingWrapper
            auto={false}
            type={'export-ta-data--asset-request-form'}
            classes={styles['loading-action-button']}
          >
            {loadingKey => (
              <ActionButton
                action={action}
                data={data}
                onActionDownload={() => {
                  download('asset-request', loadingKey);
                }}
              />
            )}
          </LoadingWrapper>
        )
      );
    },
  },
  {
    label: 'general:actions.disable_trading_account',
    icon: '#icon-disable',
    class: 'disable',
    action: 'disable',
    type: 'drawer',
    permissions: updateDisableEnableAccount,
    condition(account: Object, action: Object, callback: Function): React.Node {
      return (
        !account.archived_at &&
        account.is_enabled && <ActionButton action={action} onActionDrawer={callback} />
      );
    },
  },
  {
    label: 'general:actions.enable_trading_account',
    icon: '#icon-approve',
    class: 'enable',
    action: 'enable',
    type: 'drawer',
    permissions: updateDisableEnableAccount,
    condition(account: Object, action: Object, callback: Function): React.Node {
      return (
        !account.archived_at &&
        !account.is_enabled && <ActionButton action={action} onActionDrawer={callback} />
      );
    },
  },
  {
    label: 'general:actions.archive_trading_account',
    icon: '#icon-archive',
    class: '',
    action: 'archive',
    type: 'drawer',
    permissions: updateArchiveUnarchiveAccount,
    condition(account: Object, action: Object, callback: Function): React.Node {
      return !account.archived_at && <ActionButton action={action} onActionDrawer={callback} />;
    },
  },
  {
    label: 'general:actions.unarchive_trading_account',
    icon: '#icon-unarchive',
    class: '',
    action: 'unarchive',
    type: 'drawer',
    permissions: updateArchiveUnarchiveAccount,
    condition(account: Object, action: Object, callback: Function): React.Node {
      return account.archived_at && <ActionButton action={action} onActionDrawer={callback} />;
    },
  },
  {
    label: 'general:asset_request_form',
    icon: '#icon-terms-conditions',
    action: '',
    type: 'link',
    class: '',
    permissions: [...viewAssetRequestForm, ...viewLicenseRequestForm],
    condition(data: Object, action: Object) {
      return (
        data.asset_request_form_enabled && (
          <ActionButton
            to={{
              pathname: `/asset-request`,
            }}
            data={data}
            action={action}
          />
        )
      );
    },
  },
  {
    label: 'general:rush_asset_request_form',
    icon: '#icon-terms-conditions',
    action: '',
    type: 'link',
    class: '',
    permissions: [...rushAssetRequestFormPermissions],
    condition(data: Object, action: Object) {
      return (
        data.is_rush_asset_request_form_customer && (
          <ActionButton
            to={{
              pathname: `/asset-request-rush`,
            }}
            data={data}
            action={action}
          />
        )
      );
    },
  },
  {
    label: 'general:license_request_form',
    icon: '#icon-terms-conditions',
    action: '',
    type: 'link',
    class: '',
    permissions: [...viewAssetRequestForm, ...viewLicenseRequestForm],
    condition(data: Object, action: Object) {
      return (
        data.license_request_form_enabled && (
          <ActionButton
            to={{
              pathname: `/license-request`,
            }}
            data={data}
            action={action}
          />
        )
      );
    },
  },
];

export default actionsListData;
